import React, { useEffect, useRef } from "react";
import { Bold, Italic, List, ListOrdered, Heading2, Heading3, Link2, Table } from "lucide-react";

const Btn = ({ onClick, title, children, testid }) => (
  <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={onClick} title={title} data-testid={testid}
    className="flex h-8 w-8 items-center justify-center rounded-sm text-maroon transition-colors hover:bg-ivory">
    {children}
  </button>
);

export default function RichTextEditor({ value, onChange }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && (value || "") !== ref.current.innerHTML) {
      ref.current.innerHTML = value || "";
    }
  }, [value]);

  const exec = (cmd, arg) => {
    if (!ref.current) return;
    ref.current.focus();
    document.execCommand(cmd, false, arg);
    onChange(ref.current.innerHTML);
  };
  const addLink = () => { const url = window.prompt("Enter the link URL (https://…)"); if (url) exec("createLink", url); };
  const addTable = () => {
    exec("insertHTML",
      "<table><thead><tr><th>Heading</th><th>Heading</th></tr></thead><tbody><tr><td>Cell</td><td>Cell</td></tr><tr><td>Cell</td><td>Cell</td></tr></tbody></table><p><br/></p>");
  };
  const handleInput = () => onChange(ref.current.innerHTML);

  return (
    <div className="rte rounded-sm border border-gold/30 bg-white">
      <div className="flex flex-wrap items-center gap-1 border-b border-gold/20 p-1.5">
        <Btn onClick={() => exec("formatBlock", "H2")} title="Heading" testid="rte-h2"><Heading2 size={16} /></Btn>
        <Btn onClick={() => exec("formatBlock", "H3")} title="Subheading" testid="rte-h3"><Heading3 size={16} /></Btn>
        <Btn onClick={() => exec("formatBlock", "P")} title="Paragraph" testid="rte-p"><span className="text-xs font-semibold">P</span></Btn>
        <span className="mx-1 h-5 w-px bg-gold/30" />
        <Btn onClick={() => exec("bold")} title="Bold" testid="rte-bold"><Bold size={16} /></Btn>
        <Btn onClick={() => exec("italic")} title="Italic" testid="rte-italic"><Italic size={16} /></Btn>
        <span className="mx-1 h-5 w-px bg-gold/30" />
        <Btn onClick={() => exec("insertUnorderedList")} title="Bullet list" testid="rte-ul"><List size={16} /></Btn>
        <Btn onClick={() => exec("insertOrderedList")} title="Numbered list" testid="rte-ol"><ListOrdered size={16} /></Btn>
        <span className="mx-1 h-5 w-px bg-gold/30" />
        <Btn onClick={addLink} title="Insert link" testid="rte-link"><Link2 size={16} /></Btn>
        <Btn onClick={addTable} title="Insert table" testid="rte-table"><Table size={16} /></Btn>
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning onInput={handleInput} data-testid="rte-content"
        className="rte-content min-h-[240px] max-w-none overflow-y-auto p-4 text-sm leading-relaxed text-ink-muted focus:outline-none" />
      <style>{`
        .rte-content h2{font-family:'Cormorant Garamond',Georgia,serif;color:#58181F;font-size:1.3rem;font-weight:600;margin:1rem 0 .5rem;}
        .rte-content h3{color:#58181F;font-size:1.05rem;font-weight:600;margin:.85rem 0 .4rem;}
        .rte-content p{margin:.5rem 0;}
        .rte-content ul{list-style:disc;padding-left:1.5rem;margin:.5rem 0;}
        .rte-content ol{list-style:decimal;padding-left:1.5rem;margin:.5rem 0;}
        .rte-content a{color:#58181F;text-decoration:underline;}
        .rte-content table{border-collapse:collapse;width:100%;margin:.75rem 0;}
        .rte-content th,.rte-content td{border:1px solid rgba(184,151,104,.4);padding:.5rem .75rem;text-align:left;}
        .rte-content th{background:#FAF8F5;color:#58181F;}
        .rte-content:empty:before{content:'Start typing the policy content…';color:#9a8f86;}
      `}</style>
    </div>
  );
}
